<template>
  <div>
    <el-table
      :data="records"
      border
      size="mini"
      v-loading="loading"
      element-loading-text="正在加载中～"
    >
      <el-table-column label="姓名" prop="passengerName" align="center" />
      <el-table-column label="身份证号" prop="passengerCertificateNumber" align="center" />
      <el-table-column label="手机号" prop="passengerMobilePhone" align="center" />
      <el-table-column label="性别" prop="sex" align="center" />
      <el-table-column label="年龄" prop="age" align="center" />
      <el-table-column label="户籍地" prop="address" align="center" />
      <el-table-column label="添加日期" prop="createTime" align="center" />
      <el-table-column label="购票次数" prop="orderCount" align="center" />
    </el-table>
    <div style="display: flex; justify-content: right; margin-right: 20px; margin-top: 20px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationObj.current"
        :page-size="paginationObj.size"
        background
        layout="prev, pager, next"
        :total="total"
        size="mini"
      />
    </div>
  </div>
</template>

<script>
  import { userPassengerPage } from '@/api'
  export default {
    props: {
      passenger: {
        type: Object,
        default: () => {}
      },
      userId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        records: [],
        total: 0,
        paginationObj: {
          current: 1,
          size: 5
        },
        loading: false
      }
    },
    mounted() {
      this.records = this.passenger.records || []
      this.total = this.passenger.total || 0
    },
    methods: {
      handlePkgView(id) {
        this.pkgViewVisible = true
        this.$nextTick(() => {
          this.$refs.pkgView.init(id)
        })
      },
      closeLoading() {
        this.$loading().close()
      },
      previewInvoice(url) {
        location.href = url
      },
      async getPage() {
        this.loading = true
        const params = {
          ...this.paginationObj,
          userId: this.userId,
          state: this.state
        }
        const { code, data } = await userPassengerPage(params)
        if (code === 0) {
          const { total, records } = data
          this.records = records
          this.total = total
          this.loading = false
        }
      },
      handleCurrentChange(e) {
        this.paginationObj.current = e
        this.getPage()
      }
    }
  }
</script>

<style lang="scss" scoped></style>
